import {types} from '../../types';

const setPostDateAction = (payload) => {
    return {
        type: types.app.SET_DATE,
        payload,
      }
}

export {
  setPostDateAction as SetPostDateAction
}